<div class="container heroBanner itim-background py-80" >
    <!-- <div class="container-fluid">
        <h1 class="colorWhite text-center mb-5">{{ discipleshipTitle }}</h1>
        <div class="row align-items-center">
            <div class="col-12 col-md-12 col-lg-6 mb-5 mb-lg-0">
                <h2 class="colorWhite">{{ siscipleshipDescription }}</h2>
            </div>
        </div>
    </div>  -->
</div>

<div class="bgWhite py-80">
    <div class="container">
        <h1 class="text-center mb-5" [innerHtml]="kingsoopersTitle"></h1>
        <p [innerHtml]="kingsoopersDescription"></p>
    </div>
</div>